export default __webpack_public_path__ + "fc2ebd5a1b333acbe8ae95d9be2b39ca.webp";